<template>
  <div>
    <facit-header></facit-header>
      <div class = "profile-div col-12">
        <h5 class="mt-3 mb-3"> Sales and Marketing </h5>
        <br><br>
        <b-table  striped hover
                  :fields="fields"
                  :items="presentations">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table>
      </div>
  </div>
</template>

<script>
import FacitHeader from '@/components/header';
import API from '@/api';

export default {
  name: 'Applications',
  components: { FacitHeader },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      presentations: [],
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'version',
          label: 'Version',
          sortable: true,
        },
        {
          key: 'link',
          label: 'Downloads',
          sortable: false,
        },
      ],
    };
  },
  created() {
    this.getApplications();
  },
  methods: {
    async getApplications() {
      const downloads = await API.get('Applications');
      this.presentations = downloads;
      this.totalRows = downloads.length;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/sale.vue